import { QUERY_PROGRESS_PENDING } from "core/consts";
import { Auction, AuctionForm, Patient } from "core/types";
import { Banner } from "ds/ui";
import ConfirmationDialog from "ds_legacy/components/ConfirmationDialog";
import { useTranslations } from "translations";
import { SAVE_AND_OVERWRITE_PDF_ID } from "./RehabFormWrapper";
import { useSyncGkvInsuranceIkFromProfile } from "./useSyncGkvInsuranceIkFromProfile";
import { hasGkvInsuranceIkProfileMismatch } from "./utils";

export function GkvInsuranceIkMismatchBanner({
  auction,
  auctionForms,
  className,
  patient,
  refetchAuctionForms,
}: {
  auction: Auction;
  auctionForms: AuctionForm[];
  className?: string;
  patient: Patient;
  refetchAuctionForms?: () => Promise<unknown>;
}) {
  const translations = useTranslations();
  const { confirmProps, syncFromProfile, syncProgress } =
    useSyncGkvInsuranceIkFromProfile({
      auction,
      auctionForms,
      patient,
      refetchAuctionForms,
    });

  if (!hasGkvInsuranceIkProfileMismatch({ auctionForms, patient })) {
    return null;
  }

  return (
    <div className={className} data-testid="gkv-insurance-ik-mismatch-banner">
      <Banner
        actions={[
          {
            id: SAVE_AND_OVERWRITE_PDF_ID,
            isLoading: syncProgress === QUERY_PROGRESS_PENDING,
            label: translations.patientForms.buttonSaveOverwrite,
            onPress: () => {
              void syncFromProfile();
            },
          },
        ]}
        color="danger"
        message={translations.patientForms.insuranceIkMismatchPatientProfile}
      />
      <ConfirmationDialog {...confirmProps} />
    </div>
  );
}
